module.exports = __webpack_public_path__ + "img/auto_reviewklein.649d96c.jpg";